import Placeholder from "../components/Placeholder";

export default function Menu() {
  return (
    <Placeholder title="Menu Page" />
  );
  
}
